import React from 'react';
import { getExtension } from './bg_media';

/**
 * Renders a background video component.
 *
 * @param {Object} videoParams - The video parameters.
 * @param {Object} videoParams.backgroundMedia - The background media object.
 * @param {string} videoParams.backgroundMedia.id - The ID of the background media.
 * @param {string} videoParams.backgroundMedia.filename - The filename of the background media.
 * @param {boolean} videoParams.isLooping - Indicates whether the video should loop.
 * @returns {JSX.Element} The rendered background video component.
 */

const BgVideo = ({ videoParams }) => {
  return (
    <div className="flex h-full w-full absolute -z-10">
      <video
        key={videoParams.backgroundMedia.id}
        className="h-full w-full object-cover -z-10 rounded"
        autoPlay
        muted
        loop={videoParams.isLooping}
        playsInline
      >
        <source
          src={`${videoParams.backgroundMedia.filename}`}
          type={`video/${getExtension(videoParams.backgroundMedia.filename)}`}
        />
      </video>
    </div>
  );
};

export default BgVideo;
